module.exports = __webpack_public_path__ + "static/assets/8609697ebefd2c0b9b8056b2af43cef5.gif";